var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.664,
    height: 23.664,
    viewBox: "0 0 23.664 23.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.465,42.409a1.224,1.224,0,0,0,1.731,0l4.616-4.616a1.224,1.224,0,0,0-1.731-1.731l-2.527,2.526V25.224a1.224,1.224,0,0,0-2.448,0V38.589l-2.527-2.526a1.224,1.224,0,0,0-1.731,1.731Z",
    transform: "translate(-111.499 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.44,232a1.224,1.224,0,0,0-1.224,1.224v9.384H26.448v-9.384a1.224,1.224,0,0,0-2.448,0v9.792a2.04,2.04,0,0,0,2.04,2.04H45.624a2.04,2.04,0,0,0,2.04-2.04v-9.792A1.224,1.224,0,0,0,46.44,232Z",
    transform: "translate(0 -197.392)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b32a8c263a10ad98762d5604657acb68.svg";
export { ForwardRef as ReactComponent };